import React from 'react'
import PropTypes from 'prop-types'
import { AlignItems, Box, Color, Display, Heading6, Space } from '@gousto-internal/citrus-react'

const UserCreditMessagePresentation = ({ userCredit }) => (
  <Box
    display={Display.Flex}
    alignItems={AlignItems.Center}
    borderRadius={1}
    paddingH={3}
    paddingV={3}
    bg={Color.Success_50}
    style={{
      fontSize: '0.875rem',
      marginBottom: '1.5rem',
      minHeight: '1.25rem',
    }}
  >
    <Box width="100%">
      <Heading6>
        {`Credit £${userCredit}`}
        <Space size={2} />
      </Heading6>
      <p style={{ margin: 0 }}>
        Any credit on your account will be automatically deducted from your next payment.
      </p>
    </Box>
  </Box>
)

UserCreditMessagePresentation.propTypes = {
  userCredit: PropTypes.string.isRequired,
}

export { UserCreditMessagePresentation }
